import { useMutation } from "@tanstack/react-query";
import { Spin } from "antd";
import { Outlet, useNavigate } from "react-router-dom";

import { LOCAL_STORAGE_KEY } from "../../constants";
import { NotifyTypeEnum } from "../../constants/notify";
import Routers from "../../constants/routers";
import { logoutApi } from "../../services/api/logoutApi";
import { handleMutationError } from "../../utils/common/errors";
import { notify } from "../../utils/common/notify";

const MainLayout = () => {
  const navigate = useNavigate();

  const { mutate: logoutMutation, isPending: isLogoutPending } = useMutation({
    mutationFn: () => logoutApi(),
    onSuccess: (response: any) => {
      if (response.success) {
        localStorage.removeItem(LOCAL_STORAGE_KEY.ACCESS_TOKEN);

        window.location.href = window.location.origin + Routers.Login;
      } else {
        notify(response?.message, NotifyTypeEnum.ERROR);
      }
    },
    onError: (error: any) => {
      handleMutationError(error);
    }
  });

  const handleLogout = () => {
    logoutMutation();
  };

  return (
    <Spin spinning={isLogoutPending}>
      <div className="app-container">
        <header className="page-header">
          <button className="back-btn" onClick={() => navigate(Routers.Dashboard)}>
            ← メニューに戻る
          </button>
          <div className="header-content flex items-center">
            <h1 className="relative">
              加盟店システム
              <img
                src="/renpoppo-logo-trans.png"
                alt="れんぽっぽ Logo"
                className="h-[60px] w-auto my-[-16px] object-contain absolute left-[-150px] top-[0]"
              />
            </h1>
          </div>
          <button className="logout-btn-header" onClick={handleLogout}>
            ログアウト
          </button>
        </header>

        <main className="page-main">
          <Outlet />
        </main>
      </div>
    </Spin>
  );
};

export default MainLayout;
